/**
 * Formatting shared by the earnings page and the sharing-links popup.
 *
 * Kept in one place because the two screens show the SAME figures: a member
 * who sees ₹1,240 in the popup and INR 1240.00 on the page has to work out
 * whether they are looking at one number or two.
 */

/**
 * Money, in the currency the figures are actually in.
 *
 * `Intl` where the code is one it knows, so a member sees ₹ or $ rather than
 * a three-letter code; the code itself where it is not, which is still right
 * and never throws.
 */
export function money(amount, currency) {
  const value = Number(amount || 0);

  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "INR",
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${currency || ""} ${value.toFixed(2)}`.trim();
  }
}

/**
 * A sale's date, in the member's own locale.
 *
 * Returns "" rather than "Invalid Date" for anything unparseable: a blank
 * where a date should be is a gap, while "Invalid Date" beside real money
 * reads as the figure being wrong too.
 */
export function whenever(value) {
  if (!value) return "";

  const date = new Date(String(value).replace(" ", "T"));

  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
}
